export const warningPairs = [
  {
    trap: '页面只写「定金立减」，没写能不能退',
    action: '先分清「定金」和「订金」，再决定要不要付',
  },
  {
    trap: '大促前把参考价拉高，再打个大折扣',
    action: '把商品收藏两三周，看价格曲线而不是折扣数字',
  },
  {
    trap: '主播口播「不好吃包退」，页面里找不到售后政策',
    action: '以商品页写明的规则为准，并截图保存',
  },
  {
    trap: '维修师傅到场后，报价一路往上涨',
    action: '约上门前先问清计价方式和上门费',
  },
  {
    trap: '「保过班」合同里塞满出勤和分数前置条件',
    action: '签字前把退费条款和前提条件逐条读完',
  },
];

export const safeHabits = [
  '重大消费前先截图保存商品页与客服承诺',
  '优先选择规则写明、售后路径清晰的渠道',
  '大额支出保留完整凭证，便于后续举证',
  '对绝对化承诺保持怀疑，先找依据再下单',
];